import { subscriptionsStoreName, bindActionCreators, subscriptionActions } from '@frontegg/redux-store';
import { u as useSelector, a as useDispatch } from './FronteggStoreContext-d6c3b684.js';
import { shallowEqual } from 'react-redux';
import { useMemo } from 'react';

const usePaymentProvider = () => {
    return useSelector((state) => state[subscriptionsStoreName]['config'], shallowEqual);
};
const usePaymentProviderActions = () => {
    const dispatch = useDispatch();
    return useMemo(() => bindActionCreators(subscriptionActions.config, dispatch), [dispatch]);
};
const usePlans = () => {
    return useSelector((state) => state[subscriptionsStoreName]['plans'], shallowEqual);
};
const usePlansActions = () => {
    const dispatch = useDispatch();
    return useMemo(() => bindActionCreators(subscriptionActions.plans, dispatch), [dispatch]);
};
const useCheckout = () => {
    return useSelector((state) => state[subscriptionsStoreName]['checkout'], shallowEqual);
};
const useCheckoutActions = () => {
    const dispatch = useDispatch();
    return useMemo(() => bindActionCreators(subscriptionActions.checkout, dispatch), [dispatch]);
};
const useBilling = (billingKey) => {
    return useSelector((state) => state[subscriptionsStoreName]['billing'][billingKey], shallowEqual);
};
const useBillingActions = (billingKey) => {
    const dispatch = useDispatch();
    return useMemo(() => bindActionCreators(subscriptionActions['billing'][billingKey], dispatch), [billingKey, dispatch]);
};
const useBillingInformation = () => useBilling('information');
const useBillingInformationActions = () => useBillingActions('information');
const useBillingPaymentMethod = () => useBilling('paymentMethod');
const useBillingPaymentMethodActions = () => useBillingActions('paymentMethod');
const useInvoices = () => useBilling('invoices');
const useInvoicesActions = () => useBillingActions('invoices');
const useStripeState = () => {
    return useSelector((state) => state[subscriptionsStoreName]['stripe'], shallowEqual);
};
const useStripeActions = () => {
    const dispatch = useDispatch();
    return useMemo(() => bindActionCreators(subscriptionActions.stripe, dispatch), [dispatch]);
};

export { usePaymentProviderActions as a, usePlans as b, usePlansActions as c, useCheckout as d, useCheckoutActions as e, useBillingInformation as f, useBillingInformationActions as g, useBillingPaymentMethod as h, useBillingPaymentMethodActions as i, useInvoices as j, useInvoicesActions as k, useStripeState as l, useStripeActions as m, usePaymentProvider as u };
